import { CSSObject } from '@mui/material';

import type { Theme } from '../../themes/themes';

export const createRadioGroupTheme = (theme: Theme): Partial<Theme> => ({
  components: {
    MuiFormControlLabel: {
      styleOverrides: {
        root: {
          ...(theme.typography.button as CSSObject),
          margin: theme.spacing(6),
          color: theme.palette.text.primary,
        },
      },
    },
    MuiRadio: {
      styleOverrides: {
        root: {
          marginRight: theme.spacing(4),
          padding: 0,

          '&.Mui-checked': {
            color: theme.palette.search.checkbox['iconSelected'],
          },

          '&:hover': {
            backgroundColor: 'transparent',
          },

          '&.Mui-focusVisible': {
            outline: `2px solid ${theme.palette.action.focus}`,
            '.MuiTouchRipple-root': {
              color: 'transparent',
            },
          },

          variants: [{ props: { color: 'error' }, style: { color: theme.palette.error.main } }],
        },
      },
    },
    MuiFormLabel: {
      styleOverrides: {
        root: {
          ...(theme.typography.button as CSSObject),

          color: theme.palette.secondary['main'],

          '&.Mui-focused': {
            color: theme.palette.secondary['main'],
          },
        },
      },
    },
  },
});
